'use client';
import {FC, useEffect, useState} from 'react';
import styles from './EventsGrid.module.scss';
import { EventArrElement } from '@/models/EventModels';
import { useTranslations } from 'next-intl';
import { usePathname } from 'next/navigation';
import Arrow from '../../app/assets/icons/arrow-r.svg';
import Image from 'next/image';
import SingleEvent from '../../shared/SingleEvent';
import ContentLoader from "react-content-loader";
import getPublicEvents from "@/app/requests/getPublicEvents";
import NoEventsBlock from "@/shared/EventsGrid/NoEventsBlock/NoEventsBlock";
interface EventsGridProps {
  className?: string;
  title: string;
  allLink?: string | null;
  events?: EventArrElement[] | null;
  fetchEvents: boolean;
  tabs?: { title: string; slug: string }[];
}

const EventsGrid: FC<EventsGridProps> = (
  {
    className = '',
    title,
    allLink,
    events = null,
    fetchEvents = true,
    tabs
  }) => {
  const t = useTranslations('HOME_PAGE');

  const [loading, setLoading] = useState<boolean>(true);
  const [_events, set_events] = useState<EventArrElement[] | null>(events || null);
  const [isRecent, setIsRecent] = useState<boolean>(false);

  useEffect(() => {
    if (events) {
      set_events(events);
      setLoading(false);
      return;
    }

    if (fetchEvents) {
      getPublicEvents('upcoming').then((response) => {
        if (response.length === 0) {
          setIsRecent(true);
          getPublicEvents('recent', '-start').then((recentEvents) => {
            set_events(recentEvents);
            setLoading(false);
          });
        } else {
          set_events(response);
          setLoading(false);
        }
      });
    }
  }, [fetchEvents, events]);

  return (
    <>
      {isRecent && <NoEventsBlock className={styles.no_events}/>}
      <div className={`${styles.root} ${className} container`}>
        {isRecent &&
            <>
              <h2 className={styles.title}>{t("finished")}</h2>
              <p className={styles.subtitle}>{t("finished_description")}</p>
            </>
        }
        <div className={`${styles.events}`}>
          {loading && Array.from({length: 6}).map((_, index) => (
            <ContentLoader
              key={index}
              speed={2}
              width={475}
              height={359}
              viewBox="0 0 475 359"
              backgroundColor="#A6AECB22"
              foregroundColor="#A6AECB44"
            >
              <rect x="0" y="0" rx="24" ry="24" width="475" height="285"/>
              <rect x="16" y="305" rx="10" ry="10" width="54" height="54"/>
              <rect x="90" y="308" rx="10" ry="10" width="206" height="26"/>
              <rect x="90" y="343" rx="7" ry="7" width="115" height="14"/>
            </ContentLoader>
          ))}
          {_events &&
            _events.length > 0 &&
            _events.map((event, idx) => <SingleEvent event={event} key={idx}/>)}
        </div>
      </div>
    </>
  );
};

export default EventsGrid;
